import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Modal, ModalBody, ModalHeader } from "reactstrap";
import { ButtonCopy, ButtonInputView, ButtonRetry, ButtonSimId } from "../Button";
import { PROCESS_STATUS } from "src/constant/common";
import APP_ROUTES from "src/routes/routes";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import LoadingWrapper from "src/components/Common/Table/Loading";
import { useLocation } from "react-router-dom";
import ProtectedComponent from "src/components/Permission";

const ModalReferenceHistory = ({
  isOpen,
  simReferenceHistoryData,
  onClose,
  isGettingPageIndex,
  pageIndexId,
  handleGetPageIndexById,
  updatePageIndexById,
}) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  const [toggle, setToggle] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const projectId = params.get("projectId");
  const closeModal = () => {
    onClose();
    setToggle(false);
    setTimeout(() => {
      document.activeElement.blur();
    }, 500);
  };

  useEffect(() => {
    setToggle(isOpen);
  }, [isOpen]);

  if (isEmpty(simReferenceHistoryData)) {
    return;
  }
  return (
    <Modal centered isOpen={toggle} toggle={closeModal} className="reference-history-modal modal-width-60" backdrop="static">
      <ModalHeader className="p-b-0" toggle={closeModal}>
        {`SimID ${simReferenceHistoryData[0]?.id} Reference History`}
      </ModalHeader>
      <ModalBody className="overflow-auto">
        <Card className="border-0 mb-0">
          <CardBody className="bg-white p-0 position-relative">
            <LoadingWrapper loading={isGettingPageIndex} customClass="loading-sim-detail">
              <div className="position-relative">
                {simReferenceHistoryData.slice(0, Math.min(simReferenceHistoryData.length - 1, 4)).map((item, index) => (
                  <React.Fragment key={`${item?.id}-${index}`}>
                    <div
                      className={classNames({
                        "simulation-reference-card-opened": index === 0,
                        "simulation-reference-card": index !== 0,
                      })}
                    >
                      <div className="d-flex justify-content-between">
                        <span className="fw-bold">{t("list.table.reference_history.copy_simulation")}</span>
                        <span className="update-time">{item?.updated_at}</span>
                      </div>
                      <ButtonSimId
                        handleClick={async () => {
                          let pageIndex = pageIndexId?.[item?.id];
                          if (!pageIndex) {
                            pageIndex = await updatePageIndexById(item?.id);
                          }

                          handleGetPageIndexById(item?.id, pageIndex);
                          window.open(`${APP_ROUTES.GNC_SIMULATOR_6DOF}?id=${item?.id}&page=${pageIndex}&projectId=${projectId}`, "_blank");
                        }}
                        className="simulation-id"
                      >
                        {`SimID ${item?.id}`}
                      </ButtonSimId>
                      <p className="simulation-name">{item?.name}</p>
                      <div className="d-flex justify-content-end align-items-center gap-1">
                        <ButtonInputView
                          id={`${simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id}`}
                          prefix="refer-history"
                          handleClick={async () => {
                            let pageIndex = pageIndexId?.[item?.id];
                            if (!pageIndex) {
                              pageIndex = await updatePageIndexById(item?.id);
                            }

                            handleGetPageIndexById(item?.id, pageIndex);
                            window.open(
                              `${APP_ROUTES.GNC_SIMULATOR_6DOF}?id=${item?.id}&page=${pageIndex}&projectId=${projectId}`,
                              "_blank"
                            );
                          }}
                        />
                        <ProtectedComponent id={`retry-refer-history-${item?.id}`}>
                          <ButtonCopy
                            id={`${item?.id}`}
                            prefix="refer-history"
                            target="_blank"
                            isShow={item?.status === PROCESS_STATUS.SUCCEEDED}
                            toUrl={`${APP_ROUTES.GNC_SIMULATOR_6DOF}/${item?.id}?action=copy`}
                            noChangeCUrrentPath
                          />
                        </ProtectedComponent>
                        <ProtectedComponent id={`retry-refer-history-${item?.id}`} ownerId={item?.created_by}>
                          <ButtonRetry
                            prefix="refer-history"
                            id={`${item?.id}`}
                            target="_blank"
                            isShow={item.status === PROCESS_STATUS.FAILED}
                            toUrl={`${APP_ROUTES.GNC_SIMULATOR_6DOF}/${item?.id}?action=retry`}
                            noChangeCUrrentPath
                          />
                        </ProtectedComponent>
                      </div>
                    </div>
                    <div className="line-connector" />
                  </React.Fragment>
                ))}
                {simReferenceHistoryData.length > 5 && (
                  <div className="notice-card">
                    <span>{`${simReferenceHistoryData.length - 5} ${t("list.table.reference_history.notice_card")}`}</span>
                  </div>
                )}
                <div className="line-connector" />
                {simReferenceHistoryData.length > 0 && (
                  <div
                    className={classNames("mb-0", {
                      "simulation-reference-card-opened": simReferenceHistoryData.length === 1,
                      "simulation-reference-card": simReferenceHistoryData.length > 1,
                    })}
                  >
                    <div className="d-flex justify-content-between">
                      <span className="fw-bold">{t("list.table.reference_history.root_simulation")}</span>
                      <span className="update-time">{simReferenceHistoryData[simReferenceHistoryData.length - 1]?.updated_at}</span>
                    </div>
                    <ButtonSimId
                      handleClick={async () => {
                        const simRoot = simReferenceHistoryData[simReferenceHistoryData.length - 1];
                        let pageIndex = pageIndexId?.[simRoot?.id];
                        if (!pageIndex) {
                          pageIndex = await updatePageIndexById(simRoot?.id);
                        }

                        handleGetPageIndexById(simRoot?.id, pageIndex);
                        window.open(
                          `${APP_ROUTES.GNC_SIMULATOR_6DOF}?id=${simRoot?.id}&page=${pageIndex}&projectId=${projectId}`,
                          "_blank"
                        );
                      }}
                      className="simulation-id"
                    >
                      {`SimID ${simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id}`}
                    </ButtonSimId>
                    <p className="simulation-name">{simReferenceHistoryData[simReferenceHistoryData.length - 1]?.name}</p>
                    <div className="d-flex justify-content-end align-items-center gap-1">
                      <ButtonInputView
                        id={`${simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id}`}
                        prefix="refer-history"
                        handleClick={async () => {
                          const simRoot = simReferenceHistoryData[simReferenceHistoryData.length - 1];
                          let pageIndex = pageIndexId?.[simRoot?.id];
                          if (!pageIndex) {
                            pageIndex = await updatePageIndexById(simRoot?.id);
                          }

                          handleGetPageIndexById(simRoot?.id, pageIndex);
                          window.open(
                            `${APP_ROUTES.GNC_SIMULATOR_6DOF}?id=${simRoot?.id}&page=${pageIndex}&projectId=${projectId}`,
                            "_blank"
                          );
                        }}
                      />
                      <ProtectedComponent id={`root-copy-refer-history-${simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id}`}>
                        <ButtonCopy
                          prefix="refer-history"
                          id={`${simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id}`}
                          target="_blank"
                          isShow={simReferenceHistoryData[simReferenceHistoryData.length - 1]?.status === PROCESS_STATUS.SUCCEEDED}
                          toUrl={`${APP_ROUTES.GNC_SIMULATOR_6DOF}/${
                            simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id
                          }?action=copy`}
                          noChangeCUrrentPath
                        />
                      </ProtectedComponent>
                      <ProtectedComponent
                        id={`root-retry-refer-history-${simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id}`}
                        ownerId={simReferenceHistoryData[simReferenceHistoryData.length - 1]?.created_by}
                      >
                        <ButtonRetry
                          prefix="refer-history"
                          id={`${simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id}`}
                          target="_blank"
                          isShow={simReferenceHistoryData[simReferenceHistoryData.length - 1]?.status === PROCESS_STATUS.FAILED}
                          toUrl={`${APP_ROUTES.GNC_SIMULATOR_6DOF}/${
                            simReferenceHistoryData[simReferenceHistoryData.length - 1]?.id
                          }?action=retry`}
                          noChangeCUrrentPath
                        />
                      </ProtectedComponent>
                    </div>
                  </div>
                )}
              </div>
            </LoadingWrapper>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default ModalReferenceHistory;
